import { Role, isRole } from '@optical/rbac';

/**
 * Given a list of Cognito groups from the user's JWT, check whether the user was signed up via the
 * given auth provider.
 *
 * @param groups - A list of Cognito groups read from the access token of a user.
 * @returns True, if the user was signed up via the given auth provider; false otherwise
 */
export function hasAuthProvider(authProvider: string): (groups: string[]) => boolean {
  return (groups: string[]) => groups.some((group) => group.endsWith(authProvider));
}

/**
 * Given a list of Cognito groups from the user's JWT, parse and return all valid user roles.
 *
 * @param groups - A list of Cognito groups read from the access token of a user.
 * @returns The parsed roles
 */
export function parseRolesFromGroups(groups: string[]): Role[] {
  return groups
    .filter((group) => group.startsWith('role:'))
    .map((group) => group.replace('role:', ''))
    .filter(isRole);
}

export function parseTenantIdFromGroups(groups: string[]): string | null {
  return groups.find((group) => group.startsWith('tenant:'))?.replace('tenant:', '') ?? null;
}
